import React from 'react';

import { fetchProductsOnBackOrder } from '../api/productsOnBackOrderApi.js';

const SEARCH_DEBOUNCE_MS = 250;

export default function useProductsOnBackOrderController() {
  const [search, setSearch] = React.useState('');
  const [backOrders, setBackOrders] = React.useState([]);
  const [discontinued, setDiscontinued] = React.useState([]);
  const [counts, setCounts] = React.useState({ backOrders: 0, discontinued: 0, total: 0 });
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);

  const loadData = React.useCallback(async (searchTerm) => {
    setLoading(true);

    try {
      const data = await fetchProductsOnBackOrder({ search: searchTerm });
      setBackOrders(data.backOrders);
      setDiscontinued(data.discontinued);
      setCounts(data.counts);
      setErrorMessage(null);
    } catch (err) {
      setBackOrders([]);
      setDiscontinued([]);
      setCounts({ backOrders: 0, discontinued: 0, total: 0 });
      setErrorMessage(
        err.response?.data?.error || err.message || 'Failed to load products on back order.'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      loadData(search);
    }, SEARCH_DEBOUNCE_MS);

    return () => window.clearTimeout(timer);
  }, [loadData, search]);

  const handleSearchChange = React.useCallback((event) => {
    setSearch(event.target.value);
  }, []);

  return {
    search,
    backOrders,
    discontinued,
    counts,
    loading,
    errorMessage,
    setErrorMessage,
    handleSearchChange,
  };
}
